import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatChipInputEvent} from '@angular/material/chips';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-upcoming-cash-collections',
  templateUrl: './upcoming-cash-collections.component.html',
  styleUrls: ['./upcoming-cash-collections.component.css'],
    providers: [
      // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
      // application's root module. We provide it at the component level here, due to limitations of
      // our example generation script.
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
  
      {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})
export class UpcomingCashCollectionsComponent implements OnInit {

   partnerSearchTermUpdate = new Subject<string>();
  
    ShippingTransferListBankAccount:any;
    ShippingTransferListCurrency:any;
    Currencies:any[];
    DecimalPrecisions:any[];
    VATRates:any[];
    Periods:any[];
    DocumentStatuses:any[];
    Countries:any[];
    SuggestedCashCollections:any[];
    ShowSuggestionCashCollectionsContainer:boolean;
    ShowSuggestedCashCollectionModifier:boolean;
    ShippingCompanies:any[];
    ShippingCompany:any;
    ProofInvoiceSUMS:boolean;
  
    Filter: {[k: string]: any} = {};
    Totals: any[];
    PaidTotals:any[];
    currentPartner:any;
    currentSpending:any;
    Partners:any[];
    NewSpending:{[k: string]: any} = {};
  
    SearchedPartners:any[];
    SelectedPartner:any;
  
    Spendings:any[];
    CashCollections:any[];
    showFilter:boolean;
    ShowDeleteSpendingQuestion:boolean;
    loading:boolean;
    showEditSpendingPopUp:boolean;
    ShowCashCollectionContainer:boolean;
    ShowBankExtrasImportContainer:boolean;
    ImportExtrasBankAccount:any;
    ImportExtrasDelimiter:string;
    searchTerm:string;
    resultsLength = 0;
    pageSize = 999999;
    countryID:number;
    selectedFile: File = null;
    newBlogForm: FormGroup;
  
    activeFilters:{[k: string]: any} = [];
  
    FromDate = new FormControl(moment());
    ToDate = new FormControl(moment());
  
    CreatingDate = new FormControl(moment());
    DueDate = new FormControl(moment());
    CollectionDate = new FormControl(moment());
  
    AccountingSeries:any[];
    Languages:any[];
  
    PaymentTerms:any[];
    Administrations:any[];
    MeasuringUnits:any[];
    ProductGeneralTypes:any[];
    DiscountTypes:any[];
  
    Agents:any[];
    DocTypes:any[];
    CashCollectTypes:any[];
    currentCashCollettion:{[k: string]: any} = {};
    BankAccounts:any[];
    ShippingTransferListBankAccounts:any[];
    CashCollectImportTypes:any[];
    EmailNotificationTypes:any[];
  
    currency:any[];
    InvoicePrecision:any;
  
    Invoices:any[];
    fileUploadQueue:any[];
    CCImportType:any;
    DoNotImportDupplicateValues:boolean;
  
    ImportedFixedValue:any;
    ImportedCurrency:any;
  
    searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) {

  // Debounce search.
 this.searchPartnerUpdate.pipe(
  debounceTime(400),
  distinctUntilChanged())
  .subscribe(value => {
    this.GetPartnersFiltered(value, this.countryID, true);
  });

   }

  ngOnInit(): void {
     this.showFilter = false;
     this.InitializeFilter();
     this.GetInvoiceMasterData();
     this.GetUpcomingInvoicesToBePaid();
     this.countryID = null;
     this.NewSpending = null;
     this.DoNotImportDupplicateValues = true;
     this.ProofInvoiceSUMS = false;
 
     this.newBlogForm = new FormGroup({
       Name: new FormControl(null),
       UploadedFile: new FormControl(null)
     });
   }
 
   GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
     var request = {
       SearchTerm:searchTerm,
       CountryID:CountryID,
       PageIndex:1,
       PageSize:this.pageSize,
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       Company:this.parent.Company
     };
 
     if(this.searchTerm.length >= 3){
       this.parent.loading = true;
 
       this.service.GetPartnersFiltered(request).subscribe(response => {
      
         if(response["Status"] != 1){
           this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         }
         else if(response["Status"] == 1){
          this.Partners = response["Partners"];
          this.resultsLength = response["Count"];
         }
      
         this.parent.loading = false;
       });
     }
   }
 
   SearchPartners(searchTerm:string){
     var request = {
       SearchTerm:searchTerm,
       PageIndex:1,
       PageSize:5,
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       Company:this.parent.Company
     };
 
       this.service.GetPartnersFiltered(request).subscribe(response => {
      
         if(response["Status"] != 1){
           this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         }
         else if(response["Status"] == 1){
          this.SearchedPartners = response["Partners"];
          this.resultsLength = response["Count"];
         }
      
         this.parent.loading = false;
       });
   }
 
   GetInvoiceMasterData(){
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
     };
 
     this.service.GetInvoiceMasterData(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Currencies = response["Currencies"];
         this.DecimalPrecisions = response["DecimalPrecisions"];
         this.AccountingSeries = response["AccountingSeries"];
         this.Languages = response["Languages"];
         this.PaymentTerms = response["PaymentTerms"];
         this.Administrations = response["Administrations"];
         this.MeasuringUnits = response["MeasuringUnits"];
         this.VATRates = response["VATRates"];
         this.ProductGeneralTypes = response["ProductGeneralTypes"];
         this.DiscountTypes = response["DiscountTypes"];
         this.Agents = response["Agents"];
         this.DocTypes = response["DocTypes"];
         this.Periods = response["Periods"];
         this.DocumentStatuses = response["PaymentGeneralDocStatuses"];
         this.Countries = response["Countries"];
         this.CashCollectTypes = response["CashCollectTypes"];
         this.BankAccounts = response["BankAccounts"];
         this.ShippingTransferListBankAccounts = response["BankAccounts"];
         this.ShippingTransferListBankAccount = this.ShippingTransferListBankAccounts[0];
         this.ImportExtrasBankAccount = this.BankAccounts[0];
         this.CashCollectImportTypes = response["CashCollectImportTypes"];
         this.CCImportType = this.CashCollectImportTypes[1];
         this.currency = this.Currencies[0];
         this.ShippingTransferListCurrency = this.Currencies[0];
         this.InvoicePrecision = this.DecimalPrecisions[0];
         this.EmailNotificationTypes = response["EmailNotificationTypes"];
       }
    
       this.parent.loading = false;
     });
   }
 
   SearchInvoices(s:string){
 
     if(s.length > 2){
       var request = {
         User:this.parent.User,
         Language:this.parent.getLanguage(),
         SearchTerm:s,
         WithPartnerInfo:true
       };
   
       this.service.SearchInvoices(request).subscribe(response => {
      
         if(response["Status"] != 1){
           this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
         }
         else if(response["Status"] == 1){
           this.Invoices = response["Invoices"];
         }
      
         this.parent.loading = false;
       });
     }
   }
 
   InitializeFilter(){
 
     this.Filter = {};
     const today = moment().startOf('day');

     this.Filter.FromDate = today.toDate();
     this.Filter.ToDate = today.clone().add(3, 'days').toDate();
     
     // Sync the FormControls too (assuming you use Angular Material datepicker bound to FormControl)
     this.FromDate = new FormControl(moment(this.Filter.FromDate));
     this.ToDate = new FormControl(moment(this.Filter.ToDate));
     this.Filter.Partner = {};
     this.Filter.DocumentStatus = {};
     this.Filter.Period = {};
     this.Filter.Period = null;
     this.Filter.Country = {};
     this.Filter.Country = null;
     this.Filter.Currency = {};
     this.Filter.Currency = null;
 
     this.Filter.Type = {};
     this.Filter.Type = null;
 
     this.Filter.BankAccount = {};
     this.Filter.BankAccount = null;
 
     this.Filter.Pager = {};
     this.Filter.Pager.PageIndex = 1;
     this.Filter.Pager.PageSize = 25;
     this.Filter.Pager.TotalCount = 0;
   }
 
   InitializeNewSpending(){
     this.NewSpending = {};
     this.NewSpending.Partner = {};
     this.NewSpending.EditMode = true;
     this.NewSpending.DocumentDate = null;
     this.NewSpending.DueDate = null;
     this.NewSpending.VAT = null;
     this.NewSpending.Value = null;
     this.NewSpending.PaidValue = null;
     this.NewSpending.VATPaidValue = null;
     this.NewSpending.Currency = null;
     this.NewSpending.ShowMore = null;
     this.NewSpending.DecimalPrecision = {};
     this.NewSpending.DecimalPrecision.ID = 2;
 
     this.Spendings.forEach(e => {
       e.EditMode = false;
       e.ShowMore = false;
     });
 
     this.searchTerm = "";
   }
 
   onSelectFile(fileInput: any) {
     this.selectedFile = <File>fileInput.target.files[0];
   }
 
   CloseNewSpending(){
     this.NewSpending = null;
   }
 
   GetUpcomingInvoicesToBePaid(page = 1){
 
     this.Filter.Pager.PageIndex = page;
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       Filter:this.Filter
     };
 
     if(request.Filter.FromDate != null){
       request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
       this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
     }
 
     if(request.Filter.ToDate != null){
       request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
       this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
     }
     
     this.loading = true;
     this.showFilter = false;
 
     this.service.GetUpcomingInvoicesToBePaid(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Invoices = response["Invoices"];
         this.Totals = response["Totals"];
 
         this.FromDate = new FormControl(moment(this.Filter.FromDate));
         this.ToDate = new FormControl(moment(this.Filter.ToDate));
       }
    
       this.AllSelected = false;
       this.loading = false;
       this.GetUpcomingInvoicesToBePaidCOUNT();
     });
   }
 
   GetUpcomingInvoicesToBePaidCOUNT(){
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       Filter:this.Filter
     };
 
     if(request.Filter.FromDate != null){
       request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
       this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
     }
 
     if(request.Filter.ToDate != null){
       request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
       this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
     }
 
     this.service.GetUpcomingInvoicesToBePaidCOUNT(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Filter.Pager = response["Pager"];
       }
     });
   }
 
   ClearPeriod(){
     this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
     this.Filter.Period = null;
 
   }
 
   DisablePeriod(){
     this.Filter.Period = null;
     this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
   }
 
   AddActiveFilter(filterName:string, filterType:string){
     var filter = {
       ID:this.parent.newGuid(),
       Name:filterName,
       Type:filterType
     };
     
     if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
       this.showFilter = false;
       this.GetUpcomingInvoicesToBePaid();
     }
 
     this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
     this.activeFilters.push(filter);
 
     if(filterType == "Period"){
       this.Filter.FromDate = null;
       this.Filter.ToDate = null;
 
       this.FromDate = new FormControl(moment(this.Filter.FromDate));
       this.ToDate = new FormControl(moment(this.Filter.ToDate));
     }
   }
 
   RemoveActiveFilter(ID:string, filterType:string){
     this.activeFilters = this.activeFilters.filter(x => x.ID != ID);
 
     if(filterType == "Administration"){
       this.Filter.Administration = null;
     }
     else if(filterType == "Series"){
       this.Filter.AccountingSeries = null;
     }
     else if(filterType == "DocStatus"){
       this.Filter.DocumentStatus = null;
     }
     else if(filterType == "DocumentNumber"){
       this.Filter.DocumentNumber = null;
     }
     else if(filterType == "Product"){
       this.Filter.Product = null;
     }
     else if(filterType == "Partner"){
       this.Filter.Partner = null;
     }
     else if(filterType == "Period"){
       this.Filter.Period = null;
     }
     else if(filterType == "Country"){
       this.Filter.Country = null;
     }
     else if(filterType == "Currency"){
       this.Filter.Currency = null;
     }
     else if(filterType == "Type"){
       this.Filter.Type = null;
     }
     else if(filterType == "BankAccount"){
       this.Filter.BankAccount = null;
     }
 
     this.GetUpcomingInvoicesToBePaid();
 }
 
 compareFn(c1: any, c2: any): boolean {
   return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
 }
 
 SelectNewSpendingPartner(p:any){
 
   this.NewSpending.Partner = p;
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Company:this.parent.Company,
     Spending:this.NewSpending
   };
   
     this.parent.loading = true;
 
     this.service.PrepareNewSpendingDataOnPartnerSelect(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.NewSpending = response["NewSpending"];
 
         this.CreatingDate = new FormControl(moment(this.NewSpending.DocumentDate));
         this.DueDate =  new FormControl(moment(this.NewSpending.DueDate));
       }
    
       this.parent.loading = false;
     });
 }
 
 SelectSpendingPartner(p:any){
 
   this.currentSpending.Partner = p;
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Company:this.parent.Company,
     Spending:this.currentSpending
   };
   
     this.parent.loading = true;
 
     this.service.PrepareNewSpendingDataOnPartnerSelect(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.currentSpending = response["NewSpending"];
 
         this.CreatingDate = new FormControl(moment(this.currentSpending.DocumentDate));
         this.DueDate =  new FormControl(moment(this.currentSpending.DueDate));
 
         this.Spendings.forEach((s, index) => {
          
           if(s.ID == this.currentSpending.ID){
             this.Spendings[index] = this.currentSpending;
           }
 
         });
       }
    
       this.parent.loading = false;
     });
 }
 
 AddUpdateSpending(spending:any){
 
   if(this.CreatingDate.value._d != undefined){
     spending.DocumentDate = JSON.parse(JSON.stringify(this.CreatingDate.value._d.toLocaleDateString()));
   }
 
   if(this.DueDate.value._d != undefined){
     spending.DueDate = JSON.parse(JSON.stringify(this.DueDate.value._d.toLocaleDateString()));
   }
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Spending:spending,
   };
   
     this.parent.loading = true;
 
     this.service.AddUpdateSpending(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.GetUpcomingInvoicesToBePaid();
         var returnID = response["ID"];
 
         if(returnID > 0){
           this.UploadSpendingFile(returnID);
         }
         else{
           this.UploadSpendingFile(this.currentSpending.ID);
         }
 
         this.CloseNewSpending();
         this.GetUpcomingInvoicesToBePaid();
       }
    
       this.parent.loading = false;
     });
 }
 
 UploadSpendingFile(SpendingID:any){
     
   const request = new FormData();
   request.append('User.Id', JSON.stringify(this.parent.User.Id));
   request.append('Language', this.parent.getLanguage());
   request.append('SpendingID', SpendingID);
   request.append('UploadedFile', this.selectedFile);
   request.append('CompanyID', this.parent.Company.ID);
 
   this.parent.loading = true;
 
   this.service.UploadSpendingFile(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
     }
    
     this.parent.loading = false;
   });
 }
 
 OpenSpendingEdit(s:any){
 
   this.Spendings.forEach(e => {
     e.EditMode = false;
     e.ShowMore = false;
   });
 
   s.EditMode = true;
   this.currentSpending = s;
   this.searchTerm = this.currentSpending.Partner.Name;
   this.NewSpending = null;
 }
 
 download(filename, text) {
   var element = document.createElement('a');
   element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
   element.setAttribute('download', filename);
 
   element.style.display = 'none';
   document.body.appendChild(element);
 
   element.click();
 
   document.body.removeChild(element);
 }
 
 DownloadSpendingFile(s:any){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     SpendingID:s.ID,
   };
 
   this.parent.loading = true;
 
   this.service.DownloadSpendingFile(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       var Document = response["Document"];
       this.download(Document.Name, Document.PDFStream);
     }
 
     this.parent.loading = false;
   });
 }
 
 CancelOrActivateSpending(SpendingID:string,CancelSpending:boolean){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     SpendingID:SpendingID,
     CancelSpending:CancelSpending,
   };
 
   this.loading = true;
 
   this.service.CancelOrActivateSpending(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      this.GetUpcomingInvoicesToBePaid();
     }
 
     this.loading = false;
 
   });
 
 }
 
 DeleteCashCollection(ID:any){
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ID:ID,
   };
 
   this.parent.loading = true;
 
   this.service.DeleteCashCollection(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.CashCollections = this.CashCollections.filter(x => x.ID != ID);
       this.ShowDeleteSpendingQuestion = false;
       this.currentCashCollettion = null;
     }
 
     this.parent.loading = false;
   });
 }
 
 GetCurrencyLiveExchange(currency:any){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     Currency:currency
   };
 
   this.parent.loading = true;
 
   this.service.GetCurrencyLiveExchange(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
 
       if(this.NewSpending != null){
         this.NewSpending.Currency = response["Currency"];
       }
 
       if(this.currentSpending != null){
         this.currentSpending.Currency = response["Currency"];
       }
     }
  
     this.parent.loading = false;
   });
 }
 
 RemoveSpendingFile(SpendingID:any){
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     SpendingID:SpendingID,
   };
 
   this.parent.loading = true;
 
   this.service.RemoveSpendingFile(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.currentSpending.FilePath = null;
     }
 
     this.parent.loading = false;
   });
 }
 
 UpdateCashCollection(c:any){
 
   if(this.CollectionDate.value._d != undefined){
     c.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
   }
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CashCollect:c,
   };
   
     this.parent.loading = true;
 
     this.service.UpdateCashCollection(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.GetUpcomingInvoicesToBePaid();
       }
    
       this.parent.loading = false;
     });
 }
 
 OpenSuggestedCashCollectionModifier(c:any){
   this.currentCashCollettion = c;
   
   if(this.currentCashCollettion.InvoiceDetailsID == null || this.currentCashCollettion.InvoiceDetailsID == undefined){
     this.currentCashCollettion.InvoiceDetailsID = "";
   }
 
   if(this.currentCashCollettion.InvoiceID == null || this.currentCashCollettion.InvoiceID == undefined){
     this.currentCashCollettion.InvoiceID = "";
   }
 
   this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));
 
   if(this.currentCashCollettion.BankAccount == null){
     this.ReselectBankAccount(this.currentCashCollettion.Currency);
   }
 }
 
 CloneCashCollection(c:any){
   this.currentCashCollettion = JSON.parse(JSON.stringify(c));
   this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));
 
   if(this.currentCashCollettion.BankAccount == null){
     this.ReselectBankAccount(this.currentCashCollettion.Currency);
   }
 }
 
 SelectInvoiceForCashCollectionSearch(i:any){
   this.currentCashCollettion.InvoiceID = i.ID;
   this.currentCashCollettion.InvoiceDetailsID = i.Details.ID;
   this.currentCashCollettion.DisplayValue = i.AccountingNumber.DisplayValue;
   this.currentCashCollettion.Client = i.Client;
 
   this.currentCashCollettion.Status = this.DocumentStatuses.find(x => x.ID == 1);
   this.Invoices = null;
 }
 
 DeallocateInvoiceFromCC(){
   this.currentCashCollettion.Status = this.DocumentStatuses.find(x => x.ID == -1);
 }
 
 ExportCashCollectionsValues(){
 
   this.Filter.Pager.PageIndex = 1;
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       Filter:this.Filter
     };
 
     if(request.Filter.FromDate != null){
       request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
       this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
     }
 
     if(request.Filter.ToDate != null){
       request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
       this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
     }
     
     this.parent.loading = true;
     this.showFilter = false;
 
     this.service.ExportCashCollectionsValues(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
       }
       else if(response["Status"] == 1){
         var Document = response["Document"];
       this.download(Document.Name, Document.PDFStream);
       }
    
       this.parent.loading = false;
     });
 }
 
 InitializeNewCashCollection(){
   this.ShowCashCollectionContainer = true; 
   this.currentCashCollettion = {};
   this.currentCashCollettion.Type = this.CashCollectTypes[1];
   this.currentCashCollettion.Currency = this.Currencies[0];
   this.currentCashCollettion.Currency.DecimalPrecision = this.DecimalPrecisions[0];
   this.CollectionDate = new FormControl(moment());
   this.currentCashCollettion.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
   this.CollectionDate = new FormControl(moment(this.currentCashCollettion.CollectionDate));
   this.currentCashCollettion.ID = 0;
   this.currentCashCollettion.InvoiceDetailsID = null;
 
   this.currentCashCollettion.BankAccount = {};
   this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == this.currentCashCollettion.Currency.ID)[0];
 
   this.currentCashCollettion.InvoiceID = "";
 }
 
 InitializeNewCashCollectionCCPage(){
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
   };
   
   this.parent.loading = true;
 
   this.service.InitializeNewCashCollectionCCPage(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.currentCashCollettion = response["CashCollection"];
       this.ShowCashCollectionContainer = true;
     }
    
     this.parent.loading = false;
   });
 }
 
 ReselectBankAccount(c:any){
   this.currentCashCollettion.BankAccount = this.BankAccounts.filter(x => x.Currency.ID == c.ID)[0];
   this.InitializeCCPrecision();
 }
 
 InitializeCCPrecision(){
   if((this.currentCashCollettion.Currency?.DecimalPrecision?.ID != 0) == false){
     this.currentCashCollettion.Currency.DecimalPrecision = this.DecimalPrecisions[0];
   }
 }
 
 AddCashCollection(){
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CashCollect:this.currentCashCollettion,
   };
 
   if(this.CollectionDate.value != null){
     if(this.CollectionDate.value._d != undefined){
       request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
       this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value._d.toLocaleDateString()));
     }
     else{
       request.CashCollect.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
       this.CollectionDate = JSON.parse(JSON.stringify(this.CollectionDate.value));
     }
   }
 
   this.parent.loading = true;
 
   this.service.AddCashCollection(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.GetUpcomingInvoicesToBePaid();
     }
     
 
     this.CollectionDate = new FormControl(moment());
     this.parent.loading = false;
   });
 }
 
 OpenBankExtrasImport(){
   this.ShowBankExtrasImportContainer = true;
   this.ImportedFixedValue = null;
   this.ImportedCurrency = null;
   this.SelectedPartner = null;
   this.Filter.SearchTerm = null;
 }
 
 AllocateCashCollection(){
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CashCollect:this.currentCashCollettion,
   };
   
     this.parent.loading = true;
 
     this.service.AllocateCashCollection(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
         this.SuggestedCashCollections = response["SuggestedCashCollections"];
         this.Totals = response["Totals"];
         this.ShowSuggestionCashCollectionsContainer = true;
 
         this.ImportedFixedValue = null;
         this.ImportedCurrency = null;
       }
    
       this.parent.loading = false;
     });
 }
 
 GetBankExtrasCashCollections(){
   const request = new FormData();
   request.append('User.Id', JSON.stringify(this.parent.User.Id));
   request.append('Language', this.parent.getLanguage());
   request.append('UploadedFile', this.selectedFile);
   request.append('BankAccountID', this.ImportExtrasBankAccount.ID);
   request.append('ImportExtrasDelimiter', this.ImportExtrasDelimiter);
   request.append('CompanyID', this.parent.Company.ID);
   request.append('PartnerID', this.SelectedPartner?.ID);
   request.append('ImportedFixedValue', this.ImportedFixedValue);
   request.append('ImportedCurrencyID', this.ImportedCurrency?.ID);
   request.append('ProofInvoiceSUMS', String(this.ProofInvoiceSUMS));
 
   this.parent.loading = true;
 
   this.service.GetBankExtrasCashCollections(request).subscribe(response => {
  
     this.ShowBankExtrasImportContainer = false;
 
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
       this.SuggestedCashCollections = response["SuggestedCashCollections"];
       this.Totals = response["Totals"];
       this.ShowSuggestionCashCollectionsContainer = true;
 
       this.ImportedFixedValue = null;
       this.ImportedCurrency = null;
     }
 
     this.parent.loading = false;
   });
 }
 
 GetShippingCompanyTransferListCashCollections(){
   const request = new FormData();
   request.append('User.Id', JSON.stringify(this.parent.User.Id));
   request.append('Language', this.parent.getLanguage());
   request.append('UploadedFile', this.selectedFile);
   request.append('eShippingCompany', this.ShippingCompany.ID);
   request.append('CompanyID', this.parent.Company.ID);
   request.append('CurrencyID', this.ShippingTransferListCurrency.ID);
   request.append('BankAccountID', this.ShippingTransferListBankAccount.ID);
 
   this.parent.loading = true;
 
   this.service.GetShippingCompanyTransferListCashCollections(request).subscribe(response => {
  
     this.ShowImportShippingCompanyTransferListContainer = false;
 
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
       this.SuggestedCashCollections = response["SuggestedCashCollections"];
       this.Totals = response["Totals"];
       this.ShowSuggestionCashCollectionsContainer = true;
     }
 
     this.parent.loading = false;
   });
 }
 
 DeleteSuggestedCashCollection(c:any){
   this.SuggestedCashCollections = this.SuggestedCashCollections.filter(x => x.UIID != c.UIID);
 }
 
 ShowSuggestionCashCollectionsContainerStepTwo:boolean;
 ImportOnlyAssociatedCashCollections:boolean;
 AssociatedCashCollections:any[];
 UnAssociatedCashCollections:any[];
 
 AcceptBankExtrasStepOne(){
   this.ShowSuggestionCashCollectionsContainer = false;
   this.ShowSuggestionCashCollectionsContainerStepTwo = true;
 
   this.AssociatedCashCollections = JSON.parse(JSON.stringify(this.SuggestedCashCollections.filter(x => x.Status.ID == 1)));
   this.UnAssociatedCashCollections = JSON.parse(JSON.stringify(this.SuggestedCashCollections.filter(x => x.Status.ID == -1)));
 }
 
 BackToBankExtrasStepOne(){
   this.ShowSuggestionCashCollectionsContainer = true;
   this.ShowSuggestionCashCollectionsContainerStepTwo = false;
 }
 
 ImportCashCollections(){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CashCollections:this.SuggestedCashCollections,
     ImportType:this.CCImportType,
     DoNotImportDupplicateValues:this.DoNotImportDupplicateValues
   };
   
     this.parent.loading = true;
 
     this.service.ImportCashCollections(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
         this.GetUpcomingInvoicesToBePaid();
       }
    
       this.ShowSuggestionCashCollectionsContainerStepTwo = false;
       this.parent.loading = false;
     });
 }
 
 ShowImportShippingCompanyTransferListContainer:boolean;
 
 GetShippingCompanies(){
   
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
   };
 
     this.parent.loading = true;
 
     this.service.GetShippingCompanies(request).subscribe(response => {
       this.ShippingCompanies = response;
       this.ShowImportShippingCompanyTransferListContainer = true;
       this.ShippingCompany = this.ShippingCompanies[0];
 
       this.parent.loading = false;
     });
 }
 
 AdjustShippingTransferListBankAccount(){
   this.ShippingTransferListBankAccounts = JSON.parse(JSON.stringify(this.BankAccounts));
   this.ShippingTransferListBankAccounts = this.ShippingTransferListBankAccounts.filter(x => x.Currency.ID == this.ShippingTransferListCurrency.ID);
 
   if(this.ShippingTransferListBankAccounts.length > 0){
     this.ShippingTransferListBankAccount = this.ShippingTransferListBankAccounts[0];
   }
 }
 
 VerifyPriceModel(p:string){
   var result = this.parent.NormalizePrice(p);
 
   if(this.currentCashCollettion != null){
     this.currentCashCollettion.Value = result;
   }
 }
 
 InitializePartners(){
   if(this.SearchedPartners == null || this.SearchedPartners.length == 0){
     this.Filter.Pager.PageIndex = 1;
     this.SearchPartners(this.Filter.SearchTerm);
   }
 }
 
 ClearPartnerSearch(){
 
   this.Filter.SearchTerm = "";
   this.SearchedPartners = [];
   this.SelectedPartner = null;
  }

  AllSelected:boolean = false;

  onCheckboxDoubleClick(i:any){
    var selected = !i.IsSelected;
    this.Invoices.forEach(r => {
      
      if(r.Client.ID == i.Client.ID){
        r.IsSelected = selected;
      }
      else{
        r.IsSelected = false;
      }

    });
  }

  SelectAll(){
    this.Invoices.forEach(r => {
      r.IsSelected = this.AllSelected;
    });
  
    this.CheckIfAnyChecked();
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Invoices.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  GeneratePartnerNotificationEmailSubjectAndBody(PartnerID:string){
    this.parent.GeneratePartnerNotificationEmailSubjectAndBody(PartnerID, this.EmailNotificationTypes[3], false, this.Filter, 3);
  }
}
